import React, { CSSProperties } from 'react';
import { Switch, SwitchProps } from '@mui/material';
import { CronoSwitchWrapper } from './style';
import { colors } from 'crono-fe-common/theme';

interface IProps extends SwitchProps {
  sameSwitchColor?: boolean;
  textOn?: string;
  wrapperStyle?: CSSProperties;
}

/** @deprecated Use Switch from `@crono-one/design-system` instead. */
const CronoSwitch = ({
  textOn,
  sameSwitchColor,
  wrapperStyle,
  ...rest
}: IProps) => {
  return (
    <CronoSwitchWrapper sameSwitchColor={sameSwitchColor} style={wrapperStyle}>
      {textOn && <div className="text-on">{textOn}</div>}
      <Switch
        {...rest}
        classes={{
          thumb: 'switch-thumb',
          track: 'switch-track',
        }}
        sx={{
          '.MuiSwitch-switchBase:hover': {
            backgroundColor: sameSwitchColor
              ? `rgba(30, 186, 178, 0.04) !important`
              : undefined,
          },
          '.Mui-checked': {
            '.MuiSwitch-thumb': {
              color: colors.primary,
            },
          },
        }}
      />
    </CronoSwitchWrapper>
  );
};

export default CronoSwitch;
